import { render, staticRenderFns } from "./MTR.vue?vue&type=template&id=36b8d170&scoped=true&"
import script from "./MTR.vue?vue&type=script&lang=js&"
export * from "./MTR.vue?vue&type=script&lang=js&"
import style0 from "./MTR.vue?vue&type=style&index=0&id=36b8d170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b8d170",
  null
  
)

export default component.exports